/* eslint-disable react-hooks/rules-of-hooks */
// eslint-disable-next-line max-classes-per-file
import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Validation from '../Validation';
import {
  parse, format, alignment, formatValue,
} from '../Utils/numeriHelper';
import { getProp, setProp } from '../Utils/formHelpers';
import { getTitle, getRandomId, Presentation } from '../Utils/baseComponentHelper';
import { FormWrapperPropTypes } from '../Form/withForm';
import Restriction from '../Restriction';
import Log from '../../utils/log';
import useActivation from '../Hooks/useActivation';
import EllipsisText from '../EllipsisText';
import useValidations from '../Hooks/useValidations';
import ValidationViewer from '../Validation/ValidationViewer';
import { namecase } from '../Utils/stringHelper';

const KeyCodes = {
  Period: 190,
  DecimalPoint: 110,
  Comma: 188,
};

class Input extends React.Component {
  constructor(props) {
    super(props);
    const { stato, name, value } = this.props;
    if (stato && name && value) {
      Log.warn(`Input[${name}]: se impostato lo state e il name non deve essere impostato il value`);
    }
    this.state = {
      dirty: false,
      value: this.getValue(false),
    };
    this.uniqueid = getRandomId();

    this.formattedField = React.createRef();
    this.unformattedField = React.createRef();
  }

  componentDidMount() {
    const {
      name, addToForm, zeroValid,
    } = this.props;
    if (addToForm && name) {
      addToForm(name, this.valida(), this.reset);
    }
    const value = this.getValue();
    if (zeroValid && this.isZero(value) && format) {
      this.aggiornaValoreInput(this.formatta(value, zeroValid));
    }
  }

  UNSAFE_componentWillReceiveProps({ value, readOnly: readOnlyProp, disabled: disabledProp }) {
    const { value: valueP, readOnly: readOnlyP, zeroValid } = this.props;
    const { readOnly } = useActivation(disabledProp, readOnlyProp);
    if ((value || value === '' || (!zeroValid && this.isZero(value))) && valueP !== value) {
      this.setState({ value });
    }
    if (readOnly !== readOnlyP) {
      this.aggiornaValoreInput(this.formatta(value, zeroValid));
    }
  }

  componentWillUnmount() {
    const { name, removeFromForm } = this.props;
    if (removeFromForm && name) {
      removeFromForm(name);
    }
  }

  getTitle = () => {
    const { title, validations } = this.props;
    return getTitle(title, validations);
  };

  getAlignment() {
    const { align, format: formatP } = this.props;
    return alignment(formatP, align);
  }

  isValid = () => this.valida().valid;

  isZero = (val) => val === 0;

  getValue = (setState = true) => {
    const {
      stato, name, zeroValid, defaultValue, value: valueP,
    } = this.props;
    // eslint-disable-next-line react/destructuring-assignment
    const value = this.state ? this.state.value : valueP;
    if (stato && name) {
      return getProp(name, stato);
    }
    if (value || value === '' || (zeroValid && this.isZero(value))) {
      if (setState) this.setState({ value });
      return value;
    }
    let valueS = null;
    if (this.state) {
      const { value: valueState } = this.state;
      valueS = valueState;
    }
    if (valueS === null) {
      if (defaultValue || defaultValue === '' || (zeroValid && this.isZero(defaultValue))) {
        if (setState) this.setState({ value: defaultValue });
        return defaultValue;
      }
      if (setState) this.setState({ value: undefined });
      return undefined;
    }
    return valueS;
  };

  reset = () => {
    this.setState({ dirty: false });
  };

  clear = () => {
    this.setState({
      value: '',
    });
  };

  valida = () => {
    const {
      format: formatP, validations, zeroValid,
    } = this.props;
    if (validations === undefined) { return { valid: true }; }
    let value = this.getValue(false);
    if (formatP && value !== '' && (!value || zeroValid)) {
      value = this.formatta(+value, true);
    }
    return Validation.validateAll(validations, value);
  };

  notifica = (event) => {
    const {
      format: formatP, name, onChange, nameCase, upperCase, readOnly, stato, onFormChange,
    } = this.props;
    let value = null;
    let targetValue = event.target.value === undefined || event.target.value === null ? '' : event.target.value;
    targetValue = new Presentation({ readOnly }).parse(targetValue);
    // nel caso di restrizioni verifico che non siano passati caratteri
    // particolari (ad esempio da un incolla)
    const { restrictions } = this.props;
    if (restrictions) {
      const isNumber = typeof targetValue === 'number';
      targetValue = `${targetValue}`.split('').filter((char) => Restriction.isValid({ keyCode: char.charCodeAt(0) }, restrictions)).join('');
      if (isNumber) targetValue = Number(targetValue);
    }
    // procedo con la formattazione
    if (formatP) {
      value = parseFloat(parse(targetValue));
      if (this.formattedField.current && this.formattedField.current.value === '') {
        value = null;
      }
    } else if (nameCase) {
      // nel caso di nameCase ed uppercase formatto la stringa, e ripristino il cursore
      const hasSelection = !!this.unformattedField.current.selectionStart;
      const start = hasSelection ? this.unformattedField.current.selectionStart : 0;
      const end = hasSelection ? this.unformattedField.current.selectionEnd : 0;
      value = namecase(targetValue);
      this.unformattedField.current.value = value;
      if (hasSelection) {
        this.unformattedField.current.setSelectionRange(start, end);
      }
    } else if (upperCase) {
      const hasSelection = !!this.unformattedField.current.selectionStart;
      const start = hasSelection ? this.unformattedField.current.selectionStart : 0;
      const end = hasSelection ? this.unformattedField.current.selectionEnd : 0;
      value = targetValue.toUpperCase();
      this.unformattedField.current.value = value;
      if (hasSelection) {
        this.unformattedField.current.setSelectionRange(start, end);
      }
    } else {
      value = targetValue;
    }
    if (onFormChange && name) {
      const obj = {};
      setProp(name, value, obj, stato);
      onFormChange(obj, name, value);
    }
    this.setState({ value });
    onChange && onChange(event, value);
  };

  formatta = (value, keepZero) => {
    const { precisione, format: formatP } = this.props;
    if (!formatP) return value;
    if ((value === 0 && !keepZero) || Number.isNaN(value)) { return ''; }
    return formatValue(value, formatP, precisione);
  };

  focus = () => {
    this.formattedField.current && this.formattedField.current.focus();
    this.unformattedField.current && this.unformattedField.current.focus();
  };

  focused = () => (this.formattedField && document.activeElement === this.formattedField.current)
    || (this.unformattedField && document.activeElement === this.unformattedField.current);

  onBlur = (event) => {
    const {
      format: formatP, disabled: disabledProp, readOnly: readOnlyProp, onBlur,
    } = this.props;

    const { active } = useActivation(disabledProp, readOnlyProp);

    const newEvent = event;
    if (active) {
      newEvent.target.value = this.valueChanged(formatP, newEvent);
    }
    const { dirty } = this.state;
    if (!dirty) {
      this.setState({ dirty: true });
    }
    onBlur && onBlur(newEvent);
  };

  onKeyPress = (event) => {
    const { restrictions, onKeyPress } = this.props;
    if (restrictions) {
      if (!Restriction.isValid(event, restrictions)) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
    onKeyPress && onKeyPress(event);
  };

  onKeyDown = (event) => {
    const { format: formatP, precisione, onKeyDown } = this.props;
    if (formatP) {
      if (formatP === 'number' && !precisione
        && (event.which === KeyCodes.DecimalPoint || event.which === KeyCodes.Comma)) {
        event.preventDefault();
        event.stopPropagation();
      }
      if ((event.which === KeyCodes.Comma || event.which === KeyCodes.DecimalPoint || event.which === KeyCodes.Period)) {
        if (this.formattedField.current.value.indexOf(',') !== -1) {
          event.preventDefault();
        } else {
          event.preventDefault();
          this.formattedField.current.value = `${this.formattedField.current.value},`;
        }
      }
    }
    onKeyDown && onKeyDown(event);
  };

  aggiornaValoreInput(value) {
    const { readOnly: readOnlyProp, disabled: disabledProp } = this.props;
    const { readOnly } = useActivation(disabledProp, readOnlyProp);
    if (this.formattedField.current) {
      this.formattedField.current.value = new Presentation({ readOnly }).format(value);
    }
  }

  valueChanged(formatP, newEvent) {
    const { zeroValid } = this.props;
    let inputValue = newEvent.target.value;
    const val = newEvent.target.value;
    if (formatP) {
      let valore = this.formatta(parseFloat(parse(newEvent.target.value)), zeroValid);
      inputValue = parseFloat(parse(valore), 10);
      if (newEvent.target.value === '') {
        inputValue = null;
        valore = '';
      }
      setTimeout(() => {
        this.aggiornaValoreInput(val === '' ? '' : valore);
        if (zeroValid && val === '') { // hp cancellato, non mi deve riproposse 0
          this.notifica({ target: { value: '' } });
        } else {
          this.notifica({ target: { value: parseFloat(parse(valore), 10) } });
        }
      }, 0);
    }
    return inputValue;
  }

  renderInput(value) {
    const {
      actions,
      addToForm,
      className,
      format: formatP,
      isValid,
      nameCase,
      onBlur,
      onChange,
      onFormChange,
      onKeyDown,
      precisione,
      removeFromForm,
      resetta,
      stato,
      type,
      upperCase,
      validare,
      validations,
      value: rValue,
      title,
      zeroValid,
      name,
      defaultValue,
      restrictions,
      onKeyPress,
      readOnly: readOnlyProp,
      disabled: disabledProp,
      align,
      ellipsis,
      titleLines,
      placeholder,
      icon,
      ...others
    } = this.props;

    let newValue = value;

    const { disabled, readOnly } = useActivation(disabledProp, readOnlyProp);

    const inputClass = cns(
      'input__input',
      'validationViewer__target',
      `input__input--${this.getAlignment()}`,
      {
        'input__input--readonly': readOnly,
      },
    );

    if (readOnly) {
      let formattedValue;
      if (formatP) {
        if (zeroValid && this.isZero(newValue)) {
          formattedValue = this.formatta(+newValue, zeroValid);
        } else if (zeroValid && !newValue) {
          formattedValue = '';
        } else {
          formattedValue = this.formatta(+newValue, zeroValid);
        }
      } else {
        formattedValue = newValue;
      }
      const t = new Presentation({ readOnly }).format(formattedValue);
      return (
        <span
          className={inputClass}
          readOnly={readOnly}
          disabled={disabled}
          {...others} // eslint-disable-line react/jsx-props-no-spreading
        >
          <EllipsisText {...ellipsis}>{t}          </EllipsisText>
        </span>
      );
    }

    if (formatP) {
      if (!this.focused()) {
        if (this.formattedField.current) {
          if (parse(newValue) !== parse(this.formattedField.current.value)) {
            setTimeout(() => {
              this.aggiornaValoreInput(this.formatta(+newValue, zeroValid));
            }, 0);
          } else if (zeroValid && this.isZero(newValue)) {
            setTimeout(() => {
              this.aggiornaValoreInput(this.formatta(+newValue, zeroValid));
            }, 0);
          } else if (zeroValid && !newValue) {
            setTimeout(() => {
              this.aggiornaValoreInput('');
            }, 0);
          } else if (!newValue && !zeroValid) {
            setTimeout(() => {
              this.aggiornaValoreInput(newValue || '');
            }, 0);
          }
        } else {
          newValue = !!format && (!zeroValid || newValue !== '') ? this.formatta(+newValue, zeroValid) : newValue;
        }
      }
      return (
        <input
          id={this.uniqueid}
          autoComplete={`input-${this.uniqueid}`}
          className={inputClass}
          defaultValue={new Presentation({ readOnly }).format(newValue)}
          onBlur={this.onBlur}
          onChange={this.notifica}
          onKeyDown={this.onKeyDown}
          onKeyPress={this.onKeyPress}
          ref={this.formattedField}
          type={type || 'text'}
          data-origin={name}
          readOnly={readOnly}
          disabled={disabled}
          placeholder={placeholder}
          {...others} // eslint-disable-line react/jsx-props-no-spreading
        />
      );
    }
    if (newValue && nameCase) {
      newValue = namecase(newValue);
    } else if (newValue && upperCase) {
      newValue = newValue.toUpperCase();
    }
    return (
      <input
        id={this.uniqueid}
        autoComplete={`input-${this.uniqueid}`}
        className={inputClass}
        onBlur={this.onBlur}
        onChange={this.notifica}
        onKeyDown={this.onKeyDown}
        onKeyPress={this.onKeyPress}
        ref={this.unformattedField}
        type={type || 'text'}
        value={new Presentation({ readOnly }).format(newValue)}
        data-origin={name}
        readOnly={readOnly}
        disabled={disabled}
        placeholder={placeholder}
        {...others} // eslint-disable-line react/jsx-props-no-spreading
      />
    );
  }

  render() {
    const {
      isValid, validare, name, format: formatP, className, icon,
      title, titleLines, actions, readOnly: readOnlyProp, disabled: disabledProp,
    } = this.props;
    const { dirty } = this.state;
    const { readOnly } = useActivation(disabledProp, readOnlyProp);
    const validazione = this.valida();
    if (isValid != null && name) {
      isValid(name, validazione.valid, validazione.messages || []);
    }
    const contesto = this.getValue(false);

    const { hasError, hasWarning } = useValidations(validare, dirty, validazione);

    const classes = cns(
      'input',
      {
        'input--empty': contesto === undefined || contesto === null || contesto === '',
        'input--has-validation': hasError || hasWarning,
        'input--invalid': hasError,
        'input--valid': !hasError,
        'input--right-with-icon': icon && this.getAlignment() === 'right',
      },
      `input--titleLines${titleLines}`,
      className,
    );

    const inputTitleClass = cns('input__title', { 'input__title--readOnly': readOnly });

    const label = name || title;

    return (
      <div className={classes}>
        <div className="input__container">
          {this.renderInput(contesto)}
          {label && <label htmlFor={this.uniqueid} className="input__label">{label}</label>}
          {title && <span className={inputTitleClass}>{this.getTitle()}</span>}
          <span className="input__bar" />
          <ValidationViewer
            hasError={hasError}
            hasWarning={hasWarning}
            validazione={validazione}
            className={icon ? 'input__validation--before-icon' : undefined}
          />
          {icon && React.createElement(icon, { className: 'input__icon' })}
        </div>
        {!readOnly && actions && <div className="input__actions">{actions}</div>}
      </div>
    );
  }
}

Input.defaultProps = {
  actions: null,
  className: null,
  format: null,
  name: null,
  nameCase: false,
  upperCase: false,
  onBlur: null,
  onChange: null,
  onKeyDown: null,
  precisione: null,
  title: null,
  type: null,
  zeroValid: false,
  validations: null,
  restrictions: null,
  value: null,
  onKeyPress: null,
  readOnly: false,
  disabled: false,
  align: null,
  ellipsis: {
    left: false,
    top: true,
    disabled: false,
  },
  titleLines: 1,
  placeholder: undefined,
  icon: undefined,
};

Input.propTypes = {
  ...FormWrapperPropTypes,
  /** Azioni da associare a destra del componente */
  actions: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Indica come formattare il campo (number, currency) */
  format: PropTypes.oneOf(['currency', 'number']),
  /** Nome del campo da bindare se il componente è contenuto all'interno di un componente Form */
  name: PropTypes.string,
  /** Converte il testo in name case */
  nameCase: PropTypes.bool,
  /** Converte il testo in upper case */
  upperCase: PropTypes.bool,
  /** Presenta il campo in modalità sola lettura */
  readOnly: PropTypes.bool,
  /** Presenta il campo in modalità disabilitato */
  disabled: PropTypes.bool,
  /**
   * Callback invocata alla perdita del focus del campo:
   * <code>onBlur(event)</code>
   * dove:
   * * *event*: evento scatenante
   */
  onBlur: PropTypes.func,
  /**
   * Callback invocata al cambio di valore:
   * ```
   *  onChange(event)
   * ```
   * dove:
   * * *event*: evento scatenante
   */
  onChange: PropTypes.func,
  /**
   * Callback invocata alla pressione di un tasto con il campo in focus:
   * ```
   *  onKeyDown(event)
   * ```
   * dove:
   * * *event*: evento scatenante
   */
  onKeyDown: PropTypes.func,
  /**
   * Callback invocata alla pressione di un tasto con il campo in focus:
   * ```
   *  onKeyPress(event)
   * ```
   * dove:
   * * *event*: evento scatenante
   */
  onKeyPress: PropTypes.func,
  /** Precisione numerica */
  precisione: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  /** Etichetta da visualizzare nel campo che renderizza il componente */
  title: PropTypes.string,

  /**
Dimensione del componente.

Se il testo è lungo, utilizzare la dimensione adeguata per presentarlo in modo completo.

`medium` presenta una riga di label, `large` die righe.

ATTENZIONE: se il componente presenta una label con più righe,
allineare verso il basso tutti gli altri componenti form presentati nella stessa riga.
  */
  titleLines: PropTypes.oneOf([1, 2]),

  /** Tipo di input da renderizzare */
  type: PropTypes.string,
  /** Permette di visualizzare e gestire il setting del valore zero */
  zeroValid: PropTypes.bool,
  /** Controlli da effettuare sul campo. Per dettagli vedi
   * documentazione su *Validation* */
  validations: PropTypes.arrayOf(PropTypes.oneOfType(
    [
      PropTypes.string,
      PropTypes.object,
      PropTypes.func,
    ],
  )),
  /** Restrizione sui caratteri ammessi nel campo. Per dettagli vedi
   * documentazione su *Restriction* */
  restrictions: PropTypes.arrayOf(PropTypes.string),
  /** Valore visualizzato nel campo */
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  /**
   * Allineamento del testo.
   *
   * Tutti i numerici devono essere allineati a destra.
   */
  align: PropTypes.oneOf(['left', 'right']),
  /**
Proprietà che definisce il comporamento delle ellipsis nel caso di componente in modalità readOnly.
E' possibile definire se presentatorlo top o bottom, left o right oppure se disabilitare la visualizzazione della tooltip.

Vedi componente EllipsisText.
   */
  ellipsis: PropTypes.shape({
    /** mostra la tooltip nella parte alta/bassa */
    top: PropTypes.bool,

    /** mostra la tooltip nella parte sinistra/destra */
    left: PropTypes.bool,

    /** mostra o nasconde la tooltip */
    disabled: PropTypes.bool,
  }),

  /** Esempio testuale del dato da inserire nel campo */
  placeholder: PropTypes.string,

  /** Elemento Icona aggiunta a dx del campo di input. Es. `EuroIcon` nel caso di `format="currency"` */
  icon: PropTypes.elementType,
};

export default Input;
